/**
 * Shared class names for text inputs in conversational onboarding flows
 * (landing email, PII, session-1 tour chat). Visible border, translucent field
 * background, medium weight text, gold focus border + inset ring.
 */
export const ONBOARDING_FORM_INPUT_CLASSNAME =
  "rounded-lg border border-secondary-400/80 bg-primary-900/80 text-secondary-300 font-medium placeholder:text-secondary-400/70 focus:border-secondary-400 focus:ring-2 focus:ring-inset focus:ring-secondary-400";
